import { Setter, Show, createSignal } from "solid-js";
import STButton from "../st-button/st-button";
import { DataSourceType } from "../st-data-source-editor/st-data-source-editor";
import STInput from "../st-input/st-input";
import DataSourceEditor from "./data-source-editor";
import './create-report-wizard.css'
import { reportBrowser as api } from 'st-app/api'
import { requireReportBrowser } from "./report-browser-context";
import STCheckbox from "../st-checkbox/st-checkbox";
import { toast } from "common";
import Select from "../st-select/st-select";

type OrientationType = 'portrait' | 'landscape'

export default function CreateReportWizard() {
    const reportBrowser = requireReportBrowser()

    const [number, setNumber] = createSignal('')
    const [name, setName] = createSignal('')
    const [orientation, setOrientation] = createSignal<OrientationType>('portrait')
    const [createDefaultLayout, setCreateDefaultLayout] = createSignal(true)
    const [queryType, setQueryType] = createSignal<DataSourceType>('SQL Query')
    const [query, setQuery] = createSignal('')
    const [isLoading, setIsLoading] = createSignal(false)

    const create = async () => {
        setIsLoading(true)
        try {
            const result = await api.Create(name(), number(), queryType(), query(), orientation(), createDefaultLayout())
            if (result?.report) {
                reportBrowser.addReport(result.report)
                reportBrowser.toggleCreateMode(false)
                reportBrowser.setSelectedGroup(reportBrowser.state.groups.find(g => g.description === 'My Reports')!)
                reportBrowser.expandReport(result.report)
                if (result.warning) {
                    toast.notify('notice', `Report created without a column schema — column data will not be bound automatically. ${result.warning}`)
                }
            }
        } catch(e) {
            if (typeof e === 'string') {
                toast.notify('error', e)
            } else if (e && typeof e === 'object' && 'message' in e) {
                toast.notify('error', (e as { message: string }).message)
            } else {
                toast.notify('error', 'An error occurred while creating the report.')
            }
        }

        setIsLoading(false)
    }

    return (
        <div class="create-report-wizard flexbox">
            <div class="title-bar">
                <div style="flex-basis: 40%;">
                    <span>Report Number <span style="color: var(--st-style-error-bg)">*</span></span>
                    <STInput value={[number, setNumber]} required></STInput>
                </div>
                <div style="flex-basis: 40%;">
                    <span>Report Name <span style="color: var(--st-style-error-bg)">*</span></span>
                    <STInput value={[name, setName]} required></STInput>
                </div>
                <div>
                    <span>Orientation</span>
                    <Select<OrientationType> value={[orientation, setOrientation]} label="">
                        <Select.Option<OrientationType> value='portrait'>Portrait</Select.Option>
                        <Select.Option<OrientationType> value='landscape'>Landscape</Select.Option>
                    </Select>
                </div>
                <div class='flexbox middle'>
                    <span style='white-space: nowrap'>Default Layout</span>
                    <STCheckbox class='default-layout-checkbox' label="" value={[createDefaultLayout, setCreateDefaultLayout]}></STCheckbox>
                </div>
                <div style="flex-grow: 1"></div>
                <STButton loading={isLoading()} type="success" onClick={create}>
                    Create
                </STButton>
            </div>
            <DataSourceEditor queryType={[queryType, setQueryType]} query={[query, setQuery]}></DataSourceEditor>
        </div>
    )
}